import FEEDBACK_CONSTANTS from '@/constants/feedbackConstants';

export default {
  heading: 'Kiitos arvioinnistasi!',
  text: 'Onko jotain, mitä voisimme parantaa? Jaa mielipiteesi kanssamme.',
  form: {
    fields: [
      {
        type: 'textarea',
        name: FEEDBACK_CONSTANTS.FEEDBACK_NAME,
        placeholder: 'Mielipiteesi...'
      }
    ],
    submit: {
      label: 'Lähetä'
    }
  }
};